import * as React from 'react';

interface Props {
  field: string;
  errors: any;
}

const InlineError: React.FC<Props> = ({ field, errors }) => {
  if (!errors) {
    return null;
  }

  if (!errors[field]) {
    return null;
  }

  return (
    <div className='errors-container'>
      <ul style={{ listStyle: 'none', paddingLeft: '10px' }}>
        {errors[field].map((error: any, i: number) => (
          <li key={`e_${i}`}>{error}</li>
        ))}
      </ul>
    </div>
  );
};

export default InlineError;
